import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Components
import AdminCategoriesForm from './AdminCategoriesForm'
import AdminCategoriesEdit from './AdminCategoriesEdit'

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'

class AdminCategories extends Component {
    constructor(props) {
        super(props)
        this.props.addRoute(this.props.match)

        if (props.match.path === '/admin/products/edit') {
            this.props.setpageTitle('Edit Categories')
        } else {
            this.props.setpageTitle('Add Category')
        }
    }

    render() {
        return (
            <Switch>
                <Route path={'/admin/categories/add'} exact component={AdminCategoriesForm} />
                <Route path={'/admin/categories/edit'} component={AdminCategoriesEdit} />
            </Switch>
        )
    }
}

export default connect(null, { addRoute, setpageTitle })(AdminCategories)



// WEBPACK FOOTER //
// ./src/components/admin/categories/AdminCategories.js